import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import SubmissionsContextList from '../components/SubmissionsContextList';
import MetingenLijst from '../components/MetingenLijst';

const ProjectDetail = () => {
  const { terms } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const { gebruiker } = useAuth();
  const [project, setProject] = useState(null);
  const [taken, setTaken] = useState([]);
  const [werkorders, setWerkorders] = useState([]);
  const [bestanden, setBestanden] = useState([]);
  const [voortgang, setVoortgang] = useState({ taken: 0, werkorders: 0, totaal: 0 });
  const [loading, setLoading] = useState(true);
  const [nieuweTaak, setNieuweTaak] = useState('');
  const [nieuweTaakDeadline, setNieuweTaakDeadline] = useState('');
  const [nieuweTaakToegewezen, setNieuweTaakToegewezen] = useState('');
  const [bedrijfGebruikers, setBedrijfGebruikers] = useState([]);
  const [showKoppelModal, setShowKoppelModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkKlanten, setBulkKlanten] = useState([]);
  const [bulkSelectedKlanten, setBulkSelectedKlanten] = useState([]);
  const [bulkTitel, setBulkTitel] = useState("");
  const [bulkBeschrijving, setBulkBeschrijving] = useState("");
  const [bulkTemplate, setBulkTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [bulkZoek, setBulkZoek] = useState("");
  const [bulkCategorie, setBulkCategorie] = useState("alle");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [locaties, setLocaties] = useState([]);
  const [checklistItems, setChecklistItems] = useState([]);
  const [checks, setChecks] = useState([]);
  const [nieuweLocatie, setNieuweLocatie] = useState("");
  const [alleKlanten, setAlleKlanten] = useState([]);
  const [klantZoek, setKlantZoek] = useState("");
  const [nieuwCheckItem, setNieuwCheckItem] = useState("");
  const [beschikbareWerkorders, setBeschikbareWerkorders] = useState([]);
  const [selectedWerkorder, setSelectedWerkorder] = useState('');
  const [editProjectMode, setEditProjectMode] = useState(false);
  const [editProjectData, setEditProjectData] = useState({});
  const [ordernummerLijst, setOrdernummerLijst] = useState([]);
  useEffect(() => { api.get('/ordernummers').then(r => setOrdernummerLijst(r.data.ordernummers || [])).catch(() => {}); }, []);
  const [notities, setNotities] = useState([]);
  const [nieuweNotitie, setNieuweNotitie] = useState('');
  const [isDragging, setIsDragging] = useState(false);

  const openEditProject = () => {
    setEditProjectData({
      ordernummer: project.ordernummer || '',
      naam: project.naam || '',
      beschrijving: project.beschrijving || '',
      status: project.status || 'actief',
      start_datum: project.start_datum ? project.start_datum.slice(0,10) : '',
      eind_datum: project.eind_datum ? project.eind_datum.slice(0,10) : '',
      notities: project.notities || '',
    });
    setEditProjectMode(true);
  };

  const saveEditProject = async () => {
    try {
      await api.put(`/projecten/${id}`, editProjectData);
      setEditProjectMode(false);
      loadProject();
    } catch(e) { alert('Fout bij opslaan'); }
  };

  const verwijderProject = async () => {
    if (!window.confirm('Project definitief verwijderen? Dit kan niet ongedaan worden.')) return;
    try {
      await api.delete(`/projecten/${id}`);
      navigate('/projecten');
    } catch(e) { alert('Fout bij verwijderen'); }
  };

  useEffect(() => {
    loadProject();
    loadBeschikbareWerkorders();
    loadLocaties();
    loadKlanten();
    loadNotities();
    loadBedrijfGebruikers();
  }, [id]);

  const loadBedrijfGebruikers = async () => {
    try {
      const res = await api.get('/gebruikers');
      setBedrijfGebruikers(res.data.gebruikers || []);
    } catch (error) {
      console.error('Fout bij laden gebruikers:', error);
    }
  };

  const loadProject = async () => {
    try {
      const res = await api.get(`/projecten/${id}`);
      setProject(res.data.project);
      setTaken(res.data.taken || []);
      setWerkorders(res.data.werkorders || []);
      setBestanden(res.data.bestanden || []);
      setVoortgang(res.data.voortgang);
    } catch (error) {
      console.error('Fout bij laden project:', error);
      alert('Project niet gevonden');
      navigate('/projecten');
    } finally {
      setLoading(false);
    }
  };

  const loadBeschikbareWerkorders = async () => {
    try {
      const res = await api.get('/werkorders');
      setBeschikbareWerkorders(res.data.werkorders || []);
    } catch (error) {
      console.error('Fout bij laden werkorders:', error);
    }
  };
  const loadLocaties = async () => {
    try {
      const res = await api.get(`/project-locaties/${id}`);
      setLocaties(res.data.locaties || []);
      setChecklistItems(res.data.checklist_items || []);
      setChecks(res.data.checks || []);
    } catch (error) { console.error('Fout laden locaties:', error); }
  };
  const loadKlanten = async () => {
    try {
      const res = await api.get('/klanten');
      setAlleKlanten(res.data.klanten || res.data || []);
    } catch (error) { console.error('Fout laden klanten:', error); }
  };
  const loadNotities = async () => {
    try {
      const res = await api.get(`/projecten/${id}/notities`);
      setNotities(res.data.notities || []);
    } catch (error) { console.error('Fout laden notities:', error); }
  };
  const handleAddNotitie = async () => {
    if (!nieuweNotitie.trim()) return;
    try {
      await api.post(`/projecten/${id}/notities`, { tekst: nieuweNotitie });
      setNieuweNotitie('');
      loadNotities();
    } catch (error) { alert('Fout bij toevoegen notitie'); }
  };
  const handleDeleteNotitie = async (notitieId) => {
    if (!window.confirm('Notitie verwijderen?')) return;
    try {
      await api.delete(`/projecten/${id}/notities/${notitieId}`);
      loadNotities();
    } catch (error) { alert('Fout bij verwijderen notitie'); }
  };
  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); setIsDragging(false); };
  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    for (let i = 0; i < files.length; i++) {
      const formData = new FormData();
      formData.append('bestand', files[i]);
      try {
        await api.post(`/projecten/${id}/bestanden`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      } catch (error) { alert('Fout bij uploaden: ' + files[i].name); }
    }
    loadProject();
  };
  const loadTemplates = async () => {
    try {
      const res = await api.get('/checklists/templates');
      setTemplates(res.data.templates || res.data || []);
    } catch (error) { console.error('Fout laden templates:', error); }
  };
  const openBulkModal = async () => {
    await loadKlanten();
    loadNotities();
    await loadTemplates();
    setBulkTitel(project?.naam ? project.naam + ' - {klant}' : 'Werkorder {klant}');
    setBulkSelectedKlanten([]);
    setBulkZoek('');
    setShowBulkModal(true);
  };
  const toggleBulkKlant = (klantId) => {
    setBulkSelectedKlanten(prev => prev.includes(klantId) ? prev.filter(id => id !== klantId) : [...prev, klantId]);
  };
  const selectAllFiltered = () => {
    const filtered = alleKlanten.filter(k => k.naam.toLowerCase().includes(bulkZoek.toLowerCase()) && (bulkCategorie === "alle" || k.categorie === bulkCategorie));
    const allIds = filtered.map(k => k.id);
    const allSelected = allIds.every(id => bulkSelectedKlanten.includes(id));
    if (allSelected) {
      setBulkSelectedKlanten(prev => prev.filter(id => !allIds.includes(id)));
    } else {
      setBulkSelectedKlanten(prev => [...new Set([...prev, ...allIds])]);
    }
  };
  const handleBulkGenerate = async () => {
    if (bulkSelectedKlanten.length === 0) return alert('Selecteer minimaal 1 klant');
    if (!project?.afdeling_id) return alert('Project heeft geen afdeling');
    setBulkLoading(true);
    try {
      const res = await api.post(`/projecten/${id}/bulk-werkorders`, {
        klant_ids: bulkSelectedKlanten,
        titel_template: bulkTitel || 'Werkorder {klant}',
        beschrijving: bulkBeschrijving || null,
        afdeling_id: project.afdeling_id,
        checklist_template_id: bulkTemplate || null,
        prioriteit: 'normaal'
      });
      alert(res.data.message);
      setShowBulkModal(false);
      loadProject();
    } catch (error) { alert('Fout: ' + (error.response?.data?.message || error.message)); }
    setBulkLoading(false);
  };
  const handleAddKlantAlsLocatie = async (klant) => {
    try {
      await api.post(`/project-locaties/${id}/locatie`, { naam: klant.naam, adres: klant.adres || '' });
      setKlantZoek('');
      loadLocaties();
    } catch (error) { alert('Fout bij toevoegen'); }
  };
  const handleAddLocatie = async () => {
    if (!nieuweLocatie.trim()) return;
    try {
      await api.post(`/project-locaties/${id}/locatie`, { naam: nieuweLocatie });
      setNieuweLocatie('');
      loadLocaties();
    } catch (error) { alert('Fout bij toevoegen locatie'); }
  };
  const handleDeleteLocatie = async (locId) => {
    if (!window.confirm('Locatie verwijderen?')) return;
    try {
      await api.delete(`/project-locaties/${id}/locatie/${locId}`);
      loadLocaties();
    } catch (error) { alert('Fout bij verwijderen'); }
  };
  const handleAddCheckItem = async () => {
    if (!nieuwCheckItem.trim()) return;
    try {
      await api.post(`/project-locaties/${id}/checklist-item`, { naam: nieuwCheckItem });
      setNieuwCheckItem('');
      loadLocaties();
    } catch (error) { alert('Fout bij toevoegen item'); }
  };
  const handleDeleteCheckItem = async (itemId) => {
    try {
      await api.delete(`/project-locaties/${id}/checklist-item/${itemId}`);
      loadLocaties();
    } catch (error) { alert('Fout bij verwijderen'); }
  };
  const handleToggleCheck = async (locatieId, itemId, huidig) => {
    try {
      await api.put(`/project-locaties/${id}/check`, { locatie_id: locatieId, checklist_item_id: itemId, voltooid: !huidig });
      loadLocaties();
    } catch (error) { alert('Fout bij afvinken'); }
  };

  const handleAddTaak = async (e) => {
    e.preventDefault();
    if (!nieuweTaak.trim()) return;
    try {
      await api.post(`/projecten/${id}/taken`, {
        titel: nieuweTaak,
        deadline: nieuweTaakDeadline || null,
        toegewezen_aan: nieuweTaakToegewezen ? parseInt(nieuweTaakToegewezen, 10) : null
      });
      setNieuweTaak('');
      setNieuweTaakDeadline('');
      setNieuweTaakToegewezen('');
      loadProject();
    } catch (error) {
      alert('Fout bij toevoegen taak');
    }
  };

  const handleUpdateTaakDeadline = async (taak, nieuweDeadline) => {
    try {
      await api.put(`/projecten/${id}/taken/${taak.id}`, { deadline: nieuweDeadline || null });
      loadProject();
    } catch (error) {
      alert('Fout bij bijwerken deadline');
    }
  };

  const handleUpdateTaakToegewezen = async (taak, nieuweUserId) => {
    try {
      await api.put(`/projecten/${id}/taken/${taak.id}`, { toegewezen_aan: nieuweUserId ? parseInt(nieuweUserId, 10) : null });
      loadProject();
    } catch (error) {
      alert('Fout bij bijwerken toegewezen aan');
    }
  };

  const handleToggleTaak = async (taak) => {
    try {
      await api.put(`/projecten/${id}/taken/${taak.id}`, { afgerond: !taak.afgerond });
      loadProject();
    } catch (error) {
      alert('Fout bij bijwerken taak');
    }
  };

  const handleDeleteTaak = async (taakId) => {
    if (!window.confirm('Taak verwijderen?')) return;
    try {
      await api.delete(`/projecten/${id}/taken/${taakId}`);
      loadProject();
    } catch (error) {
      alert('Fout bij verwijderen taak');
    }
  };

  const handleKoppelWerkorder = async () => {
    if (!selectedWerkorder) return;
    try {
      await api.post(`/projecten/${id}/werkorders`, { werkorder_id: parseInt(selectedWerkorder) });
      setShowKoppelModal(false);
      setSelectedWerkorder('');
      loadProject();
    } catch (error) {
      alert('Fout bij koppelen werkorder');
    }
  };

  const handleOntkoppelWerkorder = async (werkorderId) => {
    if (!window.confirm('Werkorder ontkoppelen van dit project?')) return;
    try {
      await api.delete(`/projecten/${id}/werkorders/${werkorderId}`);
      loadProject();
    } catch (error) {
      alert('Fout bij ontkoppelen werkorder');
    }
  };

  const handleUploadBestand = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('bestand', file);
    try {
      await api.post(`/projecten/${id}/bestanden`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      loadProject();
    } catch (error) {
      alert('Fout bij uploaden bestand');
    }
  };

  const handleDeleteBestand = async (bestandId) => {
    if (!window.confirm('Bestand verwijderen?')) return;
    try {
      await api.delete(`/projecten/${id}/bestanden/${bestandId}`);
      loadProject();
    } catch (error) {
      alert('Fout bij verwijderen bestand');
    }
  };

  const handleStatusChange = async (newStatus) => {
    try {
      await api.put(`/projecten/${id}`, { status: newStatus });
      loadProject();
    } catch (error) {
      alert('Fout bij wijzigen status');
    }
  };

  const getFileIcon = (type) => {
    if (type?.includes('pdf')) return '📄';
    if (type?.includes('image')) return '🖼️';
    if (type?.includes('dwg') || type?.includes('dxf')) return '📐';
    if (type?.includes('word') || type?.includes('document')) return '📝';
    if (type?.includes('excel') || type?.includes('sheet')) return '📊';
    return '📎';
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>⏳ Laden...</div>;
  if (!project) return null;

  let dagenTotDeadline = null;
  if (project.eind_datum) {
    const einddatum = new Date(project.eind_datum);
    const vandaag = new Date();
    dagenTotDeadline = Math.ceil((einddatum - vandaag) / (1000 * 60 * 60 * 24));
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      {editProjectMode && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '32px', width: '520px', maxWidth: '90vw' }}>
            <h2 style={{ marginBottom: '24px', fontSize: '18px' }}>✏️ Project bewerken</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>Ordernummer</label>
                <select value={editProjectData.ordernummer || ''} onChange={e => setEditProjectData({...editProjectData, ordernummer: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', boxSizing: 'border-box', background: 'white' }}>
                  <option value="">- geen -</option>
                  {editProjectData.ordernummer && !ordernummerLijst.some(o => o.nummer === editProjectData.ordernummer) && <option value={editProjectData.ordernummer}>{editProjectData.ordernummer}</option>}
                  {ordernummerLijst.map(o => <option key={o.id} value={o.nummer}>{o.nummer}{o.omschrijving ? ' - ' + o.omschrijving : ''}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Naam</label>
                <input value={editProjectData.naam} onChange={e => setEditProjectData({...editProjectData, naam: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Beschrijving</label>
                <textarea value={editProjectData.beschrijving} onChange={e => setEditProjectData({...editProjectData, beschrijving: e.target.value})} rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>📝 Notities</label>
                <textarea value={editProjectData.notities} onChange={e => setEditProjectData({...editProjectData, notities: e.target.value})} rows={4} placeholder="Interne notities voor dit project..." style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Startdatum</label>
                  <input type="date" value={editProjectData.start_datum} onChange={e => setEditProjectData({...editProjectData, start_datum: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Einddatum</label>
                  <input type="date" value={editProjectData.eind_datum} onChange={e => setEditProjectData({...editProjectData, eind_datum: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={() => setEditProjectMode(false)} style={{ padding: '10px 20px', background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer' }}>Annuleren</button>
              <button onClick={saveEditProject} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}>💾 Opslaan</button>
            </div>
          </div>
        </div>
      )}
      <nav style={{ background: 'white', padding: '15px 30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <button onClick={() => navigate('/projecten')} style={{ padding: '8px 16px', background: 'white', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer' }}>← Terug</button>
          <h2 style={{ margin: 0 }}>📁 {project.naam}</h2>
          <span style={{ color: '#6b7280', fontFamily: 'monospace' }}>{project.project_code}</span>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <select value={project.status} onChange={(e) => handleStatusChange(e.target.value)} style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db' }}>
            <option value="nieuw">🆕 Nieuw</option>
            <option value="actief">🔄 Actief</option>
            <option value="afgerond">✅ Afgerond</option>
          </select>
          <button onClick={openEditProject} style={{ padding: '8px 16px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 500 }}>✏️ Bewerken</button>
          <button onClick={verwijderProject} style={{ padding: '8px 16px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 500 }}>🗑️ Verwijderen</button>
        </div>
      </nav>

      <div style={{ padding: '30px', maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header met voortgang */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', fontWeight: 'bold', color: voortgang.totaal === 100 ? '#10b981' : '#3b82f6' }}>{voortgang.totaal}%</div>
              <div style={{ color: '#6b7280' }}>Totaal Voortgang</div>
              <div style={{ background: '#e5e7eb', borderRadius: '4px', height: '8px', marginTop: '10px', overflow: 'hidden' }}>
                <div style={{ width: `${voortgang.totaal}%`, height: '100%', background: voortgang.totaal === 100 ? '#10b981' : '#3b82f6' }} />
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#8b5cf6' }}>{taken.filter(t => t.afgerond).length}/{taken.length}</div>
              <div style={{ color: '#6b7280' }}>Taken ({voortgang.taken}%)</div>
              <div style={{ background: '#e5e7eb', borderRadius: '4px', height: '6px', marginTop: '10px', overflow: 'hidden' }}>
                <div style={{ width: `${voortgang.taken}%`, height: '100%', background: '#8b5cf6' }} />
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#f59e0b' }}>{werkorders.filter(w => w.status === 'afgerond').length}/{werkorders.length}</div>
              <div style={{ color: '#6b7280' }}>Werkorders ({voortgang.werkorders}%)</div>
              <div style={{ background: '#e5e7eb', borderRadius: '4px', height: '6px', marginTop: '10px', overflow: 'hidden' }}>
                <div style={{ width: `${voortgang.werkorders}%`, height: '100%', background: '#f59e0b' }} />
              </div>
            </div>
            {project.eind_datum && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: dagenTotDeadline < 0 ? '#dc2626' : dagenTotDeadline <= 5 ? '#f59e0b' : '#10b981' }}>
                  {dagenTotDeadline < 0 ? `${Math.abs(dagenTotDeadline)} dagen over` : `${dagenTotDeadline} dagen`}
                </div>
                <div style={{ color: '#6b7280' }}>📅 Deadline: {new Date(project.eind_datum).toLocaleDateString('nl-NL')}</div>
                {dagenTotDeadline < 0 && <div style={{ color: '#dc2626', marginTop: '5px' }}>🔴 Over deadline!</div>}
                {dagenTotDeadline >= 0 && dagenTotDeadline <= 5 && <div style={{ color: '#f59e0b', marginTop: '5px' }}>⚠️ Bijna deadline</div>}
              </div>
            )}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* Taken */}
          <div style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              📋 Taken
              <span style={{ fontSize: '14px', color: '#6b7280', fontWeight: 'normal' }}>{taken.filter(t => t.afgerond).length}/{taken.length} afgerond</span>
            </h3>
            <form onSubmit={handleAddTaak} style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px', padding: '12px', background: '#f9fafb', borderRadius: '8px' }}>
              <textarea
              value={nieuweTaak}
              onChange={e => setNieuweTaak(e.target.value)}
              placeholder="Nieuwe taak toevoegen... (Enter voor nieuwe regel)"
              rows={3}
              style={{ flex: 1, padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: 'white', resize: 'vertical', fontFamily: 'inherit' }}
            />
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 150px' }}>
                  <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '2px' }}>Deadline (optioneel)</label>
                  <input type="date" value={nieuweTaakDeadline} onChange={(e) => setNieuweTaakDeadline(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                </div>
                <div style={{ flex: '1 1 150px' }}>
                  <label style={{ fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '2px' }}>Toegewezen aan (optioneel)</label>
                  <select value={nieuweTaakToegewezen} onChange={(e) => setNieuweTaakToegewezen(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }}>
                    <option value="">— niemand —</option>
                    {bedrijfGebruikers.map(g => (
                      <option key={g.id} value={g.id}>{g.voornaam} {g.achternaam}</option>
                    ))}
                  </select>
                </div>
                <button type="submit" style={{ alignSelf: 'flex-end', padding: '8px 20px', background: '#8b5cf6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}>+ Toevoegen</button>
              </div>
            </form>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {taken.map(taak => {
                const deadlineOverdue = taak.deadline && !taak.afgerond && new Date(taak.deadline) < new Date(new Date().toDateString());
                const deadlineToday = taak.deadline && !taak.afgerond && taak.deadline.slice(0,10) === new Date().toISOString().slice(0,10);
                return (
                  <div key={taak.id} style={{ padding: '12px', borderBottom: '1px solid #f3f4f6', background: taak.afgerond ? '#f0fdf4' : (deadlineOverdue ? '#fef2f2' : 'white') }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <input type="checkbox" checked={taak.afgerond} onChange={() => handleToggleTaak(taak)} style={{ marginRight: '12px', width: '20px', height: '20px', cursor: 'pointer' }} />
                      <span style={{ flex: 1, textDecoration: taak.afgerond ? 'line-through' : 'none', color: taak.afgerond ? '#6b7280' : '#1f2937' }}>{taak.titel}</span>
                      {taak.afgerond && taak.afgerond_door_naam && <span style={{ fontSize: '12px', color: '#9ca3af', marginRight: '10px' }}>✓ {taak.afgerond_door_naam}</span>}
                      <button onClick={() => handleDeleteTaak(taak.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px' }}>🗑️</button>
                    </div>
                    {!taak.afgerond && (
                      <div style={{ display: 'flex', gap: '12px', marginTop: '6px', marginLeft: '32px', fontSize: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', color: deadlineOverdue ? '#dc2626' : (deadlineToday ? '#ea580c' : '#6b7280'), fontWeight: deadlineOverdue || deadlineToday ? 600 : 400 }}>
                          📅
                          <input
                            type="date"
                            value={taak.deadline ? taak.deadline.slice(0, 10) : ''}
                            onChange={(e) => handleUpdateTaakDeadline(taak, e.target.value)}
                            style={{ padding: '2px 4px', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px' }}
                          />
                          {deadlineOverdue && <span>⚠️ verlopen</span>}
                          {deadlineToday && <span>⚠️ vandaag</span>}
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280' }}>
                          🧑‍💼
                          <select
                            value={taak.toegewezen_aan || ''}
                            onChange={(e) => handleUpdateTaakToegewezen(taak, e.target.value)}
                            style={{ padding: '2px 4px', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px' }}
                          >
                            <option value="">— niemand —</option>
                            {bedrijfGebruikers.map(g => (
                              <option key={g.id} value={g.id}>{g.voornaam} {g.achternaam}</option>
                            ))}
                          </select>
                        </label>
                      </div>
                    )}
                  </div>
                );
              })}
              {taken.length === 0 && <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af' }}>Nog geen taken. Voeg je eerste taak toe!</div>}
            </div>
          </div>

          {/* Werkorders */}
          <div style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              🔧 Gekoppelde Werkorders
              <span>
                <button onClick={() => setShowKoppelModal(true)} style={{ padding: '6px 12px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>+ Koppelen</button>
                <button onClick={openBulkModal} style={{ padding: '6px 12px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', marginLeft: '8px' }}>⚡ Bulk Genereer</button>
              </span>
            </h3>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {werkorders.map(wo => (
                <div key={wo.id} style={{ display: 'flex', alignItems: 'center', padding: '12px', borderBottom: '1px solid #f3f4f6', background: wo.status === 'afgerond' ? '#f0fdf4' : 'white' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '500' }}>#{wo.id} {wo.titel}{wo.ordernummer && <span style={{ marginLeft: 8, fontSize: 12, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: '#e0f2fe', color: '#0369a1', fontFamily: 'monospace' }}>📋 {wo.ordernummer}</span>}</div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>{wo.afdeling_naam} • {wo.status}</div>
                  </div>
                  <span style={{ padding: '4px 8px', borderRadius: '4px', fontSize: '12px', background: wo.status === 'afgerond' ? '#dcfce7' : '#fef3c7', color: wo.status === 'afgerond' ? '#166534' : '#92400e', marginRight: '10px' }}>
                    {wo.status === 'afgerond' ? '✅' : '⏳'} {wo.status}
                  </span>
                  <button onClick={() => navigate(`/werkorder/${wo.id}`)} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', marginRight: '5px' }}>👁️</button>
                  <button onClick={() => handleOntkoppelWerkorder(wo.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}>✖️</button>
                </div>
              ))}
              {werkorders.length === 0 && <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af' }}>Nog geen werkorders gekoppeld</div>}
            </div>
          </div>
        </div>

        {/* Notities */}
        <div style={{ background: '#fefce8', borderRadius: '12px', padding: '25px', marginTop: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #fde047' }}>
          <h3 style={{ marginTop: 0, color: '#854d0e' }}>📋 Notities</h3>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
            <input
              type="text"
              value={nieuweNotitie}
              onChange={e => setNieuweNotitie(e.target.value)}
               onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleAddNotitie(); } }}
              placeholder="Nieuwe notitie toevoegen..."
              style={{ flex: 1, padding: '10px 12px', border: '1px solid #fde047', borderRadius: '8px', fontSize: '14px', background: 'white' }}
            />
            <button onClick={handleAddNotitie} style={{ padding: '10px 20px', background: '#eab308', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>+ Toevoegen</button>
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {notities.map(n => (
              <div key={n.id} style={{ background: 'white', borderRadius: '8px', padding: '12px', marginBottom: '10px', border: '1px solid #fde047' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <p style={{ margin: 0, color: '#1f2937', whiteSpace: 'pre-wrap' }}>{n.tekst}</p>
                  <button onClick={() => handleDeleteNotitie(n.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px', marginLeft: '10px' }}>🗑️</button>
                </div>
                <div style={{ fontSize: '12px', color: '#a16207', marginTop: '8px' }}>
                  {n.aangemaakt_door_naam} • {new Date(n.created_at).toLocaleString('nl-NL')}
                </div>
              </div>
            ))}
            {notities.length === 0 && <p style={{ color: '#a16207', textAlign: 'center', margin: '20px 0' }}>Nog geen notities</p>}
          </div>
        </div>

        {/* Bestanden */}
        <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} style={{ background: isDragging ? '#ecfdf5' : 'white', borderRadius: '12px', padding: '25px', marginTop: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: isDragging ? '2px dashed #10b981' : '2px solid transparent', transition: 'all 0.2s' }}>
          <h3 style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            📎 Bestanden & Tekeningen
            <label style={{ padding: '6px 12px', background: '#10b981', color: 'white', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>
              + Upload
              <input type="file" onChange={handleUploadBestand} multiple style={{ display: 'none' }} />
            </label>
          </h3>
          {isDragging && <div style={{ textAlign: 'center', padding: '30px', color: '#10b981', fontWeight: 600, fontSize: '16px' }}>📂 Sleep bestanden hier om te uploaden</div>}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
            {bestanden.map(bestand => (
              <div key={bestand.id} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '10px' }}>{getFileIcon(bestand.bestand_type)}</div>
                <div style={{ fontWeight: '500', textAlign: 'center', wordBreak: 'break-word', fontSize: '14px' }}>{bestand.originele_naam}</div>
                <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '5px' }}>{(bestand.bestand_grootte / 1024 / 1024).toFixed(2)} MB</div>
                <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                  <a href={bestand.url || `/uploads/projecten/${bestand.bestand_naam}`} rel="noopener noreferrer" style={{ color: '#3b82f6', fontSize: '14px' }}>📥 Download</a>
                  <button onClick={() => handleDeleteBestand(bestand.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px' }}>🗑️</button>
                </div>
              </div>
            ))}
            {bestanden.length === 0 && !isDragging && <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Nog geen bestanden. Sleep bestanden hierheen of klik op Upload.</div>}
          </div>
        </div>

        {project.beschrijving && (
          <div style={{ background: 'white', borderRadius: '12px', padding: '25px', marginTop: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0 }}>📝 Beschrijving</h3>
            <p style={{ color: '#4b5563', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>{project.beschrijving}</p>
            <div style={{ marginTop: '15px', fontSize: '13px', color: '#9ca3af' }}>
              Aangemaakt door {project.aangemaakt_door_naam} • {project.afdeling_naam} • {new Date(project.created_at).toLocaleDateString('nl-NL')}
            </div>
          </div>
        )}
        <div style={{ background: 'white', borderRadius: '12px', padding: '25px', marginTop: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0 }}>📋 Formulieren</h3>
          <SubmissionsContextList projectId={project?.id} />
          {project?.id && <MetingenLijst projectId={project.id} />}
        </div>
      </div>

      {/* Koppel werkorder modal */}
      {showKoppelModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '12px', maxWidth: '500px', width: '90%' }}>
            <h3 style={{ marginTop: 0 }}>🔗 Werkorder Koppelen</h3>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>Selecteer een werkorder om te koppelen aan dit project.</p>
            <select value={selectedWerkorder} onChange={(e) => setSelectedWerkorder(e.target.value)} style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #d1d5db', marginBottom: '20px' }}>
              <option value="">-- Selecteer werkorder --</option>
              {beschikbareWerkorders.filter(wo => !werkorders.find(w => w.id === wo.id)).map(wo => (
                <option key={wo.id} value={wo.id}>#{wo.id} - {wo.titel}{wo.ordernummer ? ` [${wo.ordernummer}]` : ''} ({wo.status})</option>
              ))}
            </select>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowKoppelModal(false)} style={{ padding: '10px 20px', background: 'white', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer' }}>Annuleren</button>
              <button onClick={handleKoppelWerkorder} disabled={!selectedWerkorder} style={{ padding: '10px 20px', background: selectedWerkorder ? '#f59e0b' : '#d1d5db', color: 'white', border: 'none', borderRadius: '6px', cursor: selectedWerkorder ? 'pointer' : 'not-allowed' }}>Koppelen</button>
            </div>
          </div>
        </div>
      )}

      {showBulkModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '12px', maxWidth: '700px', width: '95%', maxHeight: '90vh', overflow: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>⚡ Bulk Werkorders Genereren</h3>
            <p style={{ color: '#6b7280', marginBottom: '15px' }}>Selecteer {(terms?.klant_singular || "klant").toLowerCase()}en en genereer in een keer werkorders gekoppeld aan dit project.</p>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '600', fontSize: '14px', display: 'block', marginBottom: '5px' }}>Titel template</label>
              <input type="text" value={bulkTitel} onChange={(e) => setBulkTitel(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db', boxSizing: 'border-box' }} />
              <span style={{ fontSize: '12px', color: '#9ca3af' }}>Gebruik {'{'} klant {'}'} voor de klantnaam</span>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '600', fontSize: '14px', display: 'block', marginBottom: '5px' }}>Beschrijving (optioneel)</label>
              <textarea value={bulkBeschrijving} onChange={(e) => setBulkBeschrijving(e.target.value)} placeholder="Beschrijving voor alle werkorders..." style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db', minHeight: '60px', resize: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '600', fontSize: '14px', display: 'block', marginBottom: '5px' }}>Checklist template (optioneel)</label>
              <select value={bulkTemplate} onChange={(e) => setBulkTemplate(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}>
                <option value="">-- Geen checklist --</option>
                {templates.map(t => <option key={t.id} value={t.id}>{t.naam}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <label style={{ fontWeight: '600', fontSize: '14px' }}>{terms?.klant_plural || "Klanten"} selecteren ({bulkSelectedKlanten.length} geselecteerd)</label>
                <button onClick={selectAllFiltered} style={{ padding: '4px 10px', background: '#f1f5f9', border: '1px solid #d1d5db', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Alles selecteren</button>
              </div>
              <input type="text" value={bulkZoek} onChange={(e) => setBulkZoek(e.target.value)} placeholder="Zoek klant..." style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db', marginBottom: '8px', boxSizing: 'border-box' }} />
              <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                {['alle', 'VOS', 'SBM', 'TWI', 'Voedingskast', 'Wissel', 'Spoorbezetmelding'].map(cat => (
                  <button key={cat} onClick={() => setBulkCategorie(cat)} style={{ padding: '4px 10px', borderRadius: '20px', border: bulkCategorie === cat ? 'none' : '1px solid #d1d5db', background: bulkCategorie === cat ? '#3b82f6' : 'white', color: bulkCategorie === cat ? 'white' : '#374151', cursor: 'pointer', fontSize: '12px', fontWeight: bulkCategorie === cat ? '600' : '400' }}>
                    {cat === 'alle' ? 'Alle' : cat} {cat !== 'alle' && '(' + alleKlanten.filter(k => k.categorie === cat).length + ')'}
                  </button>
                ))}
              </div>
              <div style={{ maxHeight: '250px', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '6px' }}>
                {alleKlanten.filter(k => k.naam.toLowerCase().includes(bulkZoek.toLowerCase()) && (bulkCategorie === 'alle' || k.categorie === bulkCategorie)).map(k => (
                  <div key={k.id} onClick={() => toggleBulkKlant(k.id)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', background: bulkSelectedKlanten.includes(k.id) ? '#eff6ff' : 'white' }}>
                    <div style={{ width: '22px', height: '22px', borderRadius: '4px', border: bulkSelectedKlanten.includes(k.id) ? 'none' : '2px solid #d1d5db', background: bulkSelectedKlanten.includes(k.id) ? '#3b82f6' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', flexShrink: 0 }}>{bulkSelectedKlanten.includes(k.id) ? '✓' : ''}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: '500' }}>{k.naam}</div>
                      <div style={{ fontSize: '12px', color: '#9ca3af' }}>{k.adres || ''}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowBulkModal(false)} style={{ padding: '10px 20px', background: 'white', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer' }}>Annuleren</button>
              <button onClick={handleBulkGenerate} disabled={bulkLoading || bulkSelectedKlanten.length === 0} style={{ padding: '10px 20px', background: bulkSelectedKlanten.length > 0 ? '#3b82f6' : '#d1d5db', color: 'white', border: 'none', borderRadius: '6px', cursor: bulkSelectedKlanten.length > 0 ? 'pointer' : 'not-allowed', fontWeight: '600' }}>
                {bulkLoading ? 'Bezig...' : 'Genereer ' + bulkSelectedKlanten.length + ' werkorders'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetail;
